import OttawaFooter from "./OttawaFooter";
import SFFooter from "./SFFooter";
import TorontoFooter from "./TorontoFooter";
import React from "react";

const FlexFooter = ({region}) => {

    switch(region) {
        case "ott":
          return <OttawaFooter/>
        case "nyc":
            return <SFFooter/>
        case "tor":
            return <TorontoFooter/>
        break;
        case "sf":
            return <SFFooter/>
        break;
        default:
            return <TorontoFooter/>
      }
}

export default FlexFooter;


// WEBPACK FOOTER //
// ./src/components/Layout/FlexFooter.js